import Cookies from "js-cookie";
const cookieKey = 'lastNewsletterPopup';

$('.download-link').on('click', function() {
	if (window.meldaSettings.hasNewsletter) return;

	const now = Math.round(Date.now() / 1000);
	const timeout = window.meldaSettings.newsletterPopupTimeout;
	if (!timeout) return;

	const notShowYet = Cookies.get(cookieKey);
	if (notShowYet) {
		return;
	} else {
		const expires = new Date(Date.now() + timeout * 1000);
		Cookies.set(cookieKey, now, {expires});
		$('#newsletterModal').modal('show');
	}
});
